// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextTuesday as fn } from "../nextTuesday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextTuesday = convertToFP(fn, 1);

// Fallback for modularized imports:
export default nextTuesday;
